export default __webpack_public_path__ + "static/events-light-a98eed6ccb79f10f36d8e6d13c05c6bc.png";